import { useMemo } from 'react'

import { ItemsLine } from 'core-components/library/multiSelect'
import { IDataProviderFilter, IFilter } from 'core-components/types'

import { FilterLineItemTemplate } from './FilterLineItemTemplate'

export interface IFilterLineProps {
  filter: IDataProviderFilter
  ignoredFields?: string[]
  handleRemoveField: (value: IDataProviderFilter) => void
  onFilterRender?: (filter: IDataProviderFilter | IFilter) => any
}

export const FilterLine = ({
  filter,
  ignoredFields,
  handleRemoveField,
  onFilterRender,
}: IFilterLineProps) => {
  const currFilter = useMemo(() => {
    const arr = [] as IFilter[]
    filter &&
      filter.filters.map((el: any) => {
        if (!ignoredFields || !ignoredFields.find((field) => field === el.field)) {
          arr.push(el)
        }
      })
    return arr
  }, [filter, ignoredFields])

  return (
    <ItemsLine
      value={currFilter}
      onDeleteValue={(f) => {
        if (filter) {
          filter.filters = filter.filters.filter((el) => el !== f)
          handleRemoveField(filter)
        }
      }}
      itemTemplate={(data) => (
        <FilterLineItemTemplate
          {...data}
          customValueRender={onFilterRender ? onFilterRender(data.item) : undefined}
        />
      )}
      caption={'caption'}
    />
  )
}
